<template>
  <div id="Deposit" class="container" dir="rtl">
    <loading v-if="Lodaingrenre"></loading>
    <!-- <loading v-if="$store.state.loadingRender"></loading> -->
    <div class="row">
      <div class="col-12 text-center">
        <!-- <panel Title="فرم واریز وجه" Des="از طریق این فرم می توانید به حساب های خود واریز انجام دهید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right"></panel> -->
        <div class="row">
          <div v-if="IsShowComboHesab" class="col-md-1 col-12"></div>
          <div v-if="IsShowComboHesab" class="col-md-10 col-12">
            <div class="row">
              <div class="card w-100 mb-1 border border-secondary p-2">
                <select name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer text-center" v-model="Resultcmb" @change="FindTaahod(Resultcmb)" style="font-size: 15px !important">
                  <option disabled value="-1" style="font-size: 15px !important">-- یکی از حساب های خود را انتخاب کنید --</option>
                  <option v-for="item in this.ListModel" :key="item.id" :value="item.id" style="font-size: 15px !important">
                    <span>{{ item.vcodeDesNo }} </span><span>{{ item.nameFamily }} </span>
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div v-if="IsShowComboHesab" class="col-md-1 col-12"></div>

          <div class="col-md-1 col-12"></div>
          <div class="col-md-10 col-12 card Netpa-Shadow p-4 mt-1">
            <div class="row">
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <div class="border-bottom border-warning pb-2">
                      <b v-if="!IsTashilat" style="font-size: 15px !important" class="text-dark"> اطلاعات حساب</b>
                      <b v-else style="font-size: 15px !important" class="text-dark"> اطلاعات تسهیلات</b>
                    </div>
                    <div v-if="!IsTashilat" class="row mt-2">
                      <div class="col-md-6 col-12 text-right">
                        <span class="no-wrap">شمــاره حساب</span>
                      </div>
                      <div class="col-md-6 col-12 text-left">
                        <small class="no-wrap">{{ TaahodatItem && TaahodatItem.vCode ? TaahodatItem.vCode : '' }}{{ TahoodSelected != null && TahoodSelected.vCode ? TahoodSelected.vCode : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">شنـــاسه واریز</span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TaahodatItem && TaahodatItem.shenaseVariz ? TaahodatItem.shenaseVariz : '' }}{{ TahoodSelected != null && TahoodSelected.shenaseVariz ? TahoodSelected.shenaseVariz : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">موجودی قابل برداشت </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TaahodatItem && TaahodatItem.ghabelBardasht ? $Comma3ragham(TaahodatItem.ghabelBardasht) : '' }} {{ TahoodSelected != null && TahoodSelected.ghabelBardasht ? $Comma3ragham(TahoodSelected.ghabelBardasht) : '' }}</small>
                      </div>
                      <div class="col-12 mt-3 text-right">
                        <span class="text-dark">مبلـــغ واریزی</span>
                        <input dir="rtl" id="MabGhest" class="form-control text-center 3ragham mt-1" @keypress="$ValidNumber($event, 11)" :disabled="FixVarizHesabha" style="font-size: 14px !important" v-model="Mablagh" />
                      </div>
                      <div class="col-12 mt-3 text-center">
                        <span class="d-block" style="font-size: 14px !important">{{ Mab2persian }}</span>
                      </div>
                    </div>
                    <div v-if="IsTashilat && !IsShowComboHesab" class="row mt-2">
                      <div class="col-md-6 col-12 text-right">
                        <span class="no-wrap">شمــاره تسهیلات</span>
                      </div>
                      <div class="col-md-6 col-12 text-left">
                        <small class="no-wrap">{{ TaahodatItem && TaahodatItem.vCode ? TaahodatItem.vCode : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">شنـــاسه واریز</span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TaahodatItem && TaahodatItem.shenaseVariz ? TaahodatItem.shenaseVariz : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">تاریخ شروع اقساط </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TaahodatItem && TaahodatItem.tarixShoroAghsat }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مبلغ تسهیلات </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ $Comma3ragham(TaahodatItem.mablaghVam) }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مانده تسهیلات </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ $Comma3ragham(TaahodatItem.mande) }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مبلغ قسط </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ $Comma3ragham(TaahodatItem.mablaghGhestVam) }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">شنـــاسه واریز</span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TaahodatItem && TaahodatItem.shenaseVariz ? TaahodatItem.shenaseVariz : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">تعداد اقساط </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TaahodatItem.tedadGhestVam }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مبلــغ جریمه</span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap text-danger">{{ TaahodatItem.wwwJarime == null ? 0 : $Comma3ragham(TaahodatItem.wwwJarime) }}</small>
                      </div>
                      <div class="col-12 mt-3 text-right">
                        <div v-if="IsTashilat" class="row">
                          <div class="col-md-12 col-12 mt-1 text-right">
                            <span class="text-dark">مبلـــغ قسط</span>
                            <input id="MabGhest" class="form-control text-center 3ragham mt-1" :disabled="FixVariz" @keypress="$ValidNumber($event, 11)" type="text" style="font-size: 14px !important" v-model="Mablagh" />
                          </div>
                          <div class="col-md-2 pr-0 col-2 mt-2 pl-0 text-right">
                            <!-- <button
                              type="button"
                              @click="
                                SendIdToTaahodatRiz(
                                  TaahodatItem ? TaahodatItem.id : null
                                )
                              "
                              class="btn btn-outline-orange mt-3"
                              style="font-size: 14px !important"
                              data-toggle="modal"
                              data-target="#ModalBanafash"
                              dir="ltr"
                            >
                              <span class="fa fa-list" tabindex="-1"></span>
                            </button> -->
                          </div>
                        </div>
                        <div v-else>
                          <span class="text-dark">مبلـــغ قسط</span>
                          <input id="MabGhest" class="form-control text-center 3ragham mt-1" :disabled="FixVariz" @keypress="$ValidNumber($event, 11)" type="text" style="font-size: 14px !important" v-model="Mablagh" />
                          {{ FixVariz }}
                        </div>
                      </div>
                      <div class="col-12 mt-3 text-center">
                        <span class="d-block" style="font-size: 14px !important">{{ Mab2persian }}</span>
                      </div>
                    </div>
                    <div v-if="IsTashilat && IsShowComboHesab" class="row mt-2">
                      <div class="col-md-6 col-12 text-right">
                        <span class="no-wrap">شمــاره تسهیلات</span>
                      </div>
                      <div class="col-md-6 col-12 text-left">
                        <small class="no-wrap">{{ TahoodSelected != null && TahoodSelected.vCode ? TahoodSelected.vCode : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">شنـــاسه واریز</span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TahoodSelected && TahoodSelected.shenaseVariz ? TahoodSelected.shenaseVariz : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">تاریخ شروع اقساط </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TahoodSelected && TahoodSelected.tarixShoroAghsat }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مبلغ تسهیلات </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TahoodSelected ? $Comma3ragham(TahoodSelected.mablaghVam) : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مانده تسهیلات </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TahoodSelected ? $Comma3ragham(TahoodSelected.mande) : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مبلغ قسط </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TahoodSelected ? $Comma3ragham(TahoodSelected.mablaghGhestVam) : '' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">تعداد اقساط </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap">{{ TahoodSelected && TahoodSelected.tedadGhestVam }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">مبلــغ جریمه</span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap text-danger" id="MabJarime">{{ TahoodSelected && TahoodSelected.wwwJarime ? $Comma3ragham(TahoodSelected.wwwJarime) : 'ندارد' }}</small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-md-2">
                        <span class="no-wrap">سررسید قسط پرداخت نشده </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-md-2">
                        <small class="no-wrap text-danger" id="minTarGhestBedehkar">{{ TahoodSelected && TahoodSelected.minTarGhestBedehkar ? TahoodSelected.minTarGhestBedehkar : 'ندارد' }}</small>
                      </div>
                      <div class="col-12 mt-3 text-right">
                        <div v-if="IsTashilat" class="row">
                          <div class="col-md-12 col-12 mt-1 text-right">
                            <span class="text-dark">مبلـــغ قسط</span>
                            <input id="MabGhest" class="form-control text-center 3ragham mt-1" :disabled="FixVariz" @keypress="$ValidNumber($event, 11)" type="text" style="font-size: 14px !important" v-model="Mablagh" />
                          </div>
                          <div class="col-md-2 pr-0 col-2 mt-2 pl-0 text-right">
                            <!-- <button
                              type="button"
                              @click="
                                SendIdToTaahodatRiz(
                                  TahoodSelected ? TahoodSelected.id : null
                                )
                              "
                              class="btn btn-outline-orange mt-3"
                              style="font-size: 14px !important"
                              data-toggle="modal"
                              data-target="#ModalBanafash"
                              dir="ltr"
                            >
                              <span class="fa fa-list" tabindex="-1"></span>
                            </button> -->
                          </div>
                        </div>
                        <div v-else>
                          <span class="text-dark">مبلـــغ قسط</span>
                          <input id="MabGhest" dir="rtl" class="form-control text-center 3ragham mt-1" :disabled="FixVariz" @keypress="$ValidNumber($event, 11)" type="text" style="font-size: 14px !important" v-model="Mablagh" />
                        </div>
                      </div>

                      <div class="col-12 mt-3 text-center">
                        <span class="d-block" style="font-size: 14px !important">{{ Mab2persian }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="border-bottom border-warning pb-2">
                      <b style="font-size: 15px !important" class="text-dark"> اطلاعات واریز کننده</b>
                    </div>
                    <!-- <div class="alert bg-dark-Custom text-center w-100 mt-2">
                                            <b class="text-warning" style="font-size:15px !important;">اطلاعات واریزی ، </b>
                                            <span class="text-light">اطلاعات شما به عنوان واریز کننده ثبت میگردد ، که می توانید اطلاعات خودرا در باکس زیر مشاهده کنید</span>
                                        </div> -->
                    <div class="row mt-2">
                      <div class="col-md-4 col-12 text-right">
                        <span class="no-wrap">مشخصات </span>
                      </div>
                      <div class="col-md-8 col-12 text-left">
                        <small>{{ $session.get('UserInfoNetPa').ozvName + ' ' + $session.get('UserInfoNetPa').ozvFamily }} </small>
                      </div>
                      <div class="col-md-6 col-12 text-right mt-2">
                        <span class="no-wrap">کد ملی </span>
                      </div>
                      <div class="col-md-6 col-12 text-left mt-2">
                        <small>
                          {{ $session.get('UserInfoNetPa').codeMeli }}
                        </small>
                      </div>
                      <div class="col-md-4 col-12 text-right mt-2">
                        <span class="no-wrap">همراه </span>
                      </div>
                      <div class="col-md-8 col-12 text-left mt-2">
                        <small>
                          {{ $session.get('UserInfoNetPa').mobile }}
                        </small>
                      </div>
                      <!-- <div class="col-12 mt-3 text-right ">
                                                <span class="text-dark">ایمیل </span>
                                                <input v-model="Email" type="email" dir="ltr" class="form-control text-center mt-1" style="font-size:14px !important;" >
                                            </div> -->
                    </div>
                  </div>
                  <!-- <div class="col-12 mt-3 text-right ">
                                        <small>توضیحات واریزی</small>
                                        <textarea class="form-control text-center mt-1" style="font-size:20px !important;" rows="2" v-model="Des"></textarea>
                                    </div> -->
                </div>
              </div>
              <div class="col-md-6 col-12">
                <payment @GatewayCode="Get_GatewayCode" @FixVarizGhest="FixVarizGhest" :ShowCustomDeposit="IsTashilat || (IsTashilat && IsShowComboHesab)">
                  <template v-slot:ContentButtonPayment>
                    <button v-if="GatewayCode != 100" :disabled="Mablagh.replace(/,/g, '') < 10000 ? true : false" class="btn btn-success btn-block" @click="Payment">واریز {{ GetMablagh }}</button>
                    <div class="mt-5">
                      <h6 v-if="GatewayCode == 100" class="text-danger">لطفا یکی از حساب های خودرا جهت واریز قسط انتخاب نمایید</h6>
                      <select v-if="GatewayCode == 100 && ListHesbForPar != null" v-model="HesabForDeposit" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer text-center" style="font-size: 15px !important">
                        <option disabled value="-1" style="font-size: 15px !important">-- یکی از حساب های خود را انتخاب کنید --</option>
                        <option v-for="item in ListHesbForPar" :key="item.id" :value="item" style="font-size: 15px !important">
                          <span>{{ item.vcodeDesNo }} </span><span>{{ item.nameFamily }} </span>
                        </option>
                      </select>
                      <div v-if="GatewayCode == 100 && HesabForDeposit" class="text-dark font-weight-bold mt-2">مبلغ قابل برداشت {{ $Comma3ragham(Number(HesabForDeposit.ghabelBardasht) + Number(HesabForDeposit.sumMabTaeedNaShode)) }}</div>
                      <button v-if="GatewayCode == 100 && HesabForDeposit" class="btn btn-success btn-block mt-4" @click="Payment2">واریز {{ GetMablagh }} از حساب {{ HesabForDeposit.nameFamily }} {{ HesabForDeposit.desNoe }}</button>
                    </div>
                  </template>
                </payment>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-12"></div>
        </div>
        <!-- <modal-custom>
          <template v-slot:ContentModalSuccess> </template>
          <template v-slot:ContentModalBanafash>
            <taahodat-riz
              v-if="$store.state.renderComponent"
              @SumMablagh="SumMablagh"
              :taahodatId="TaahodatIdForGetRiz"
            ></taahodat-riz>
          </template>
        </modal-custom> -->
      </div>
    </div>
  </div>
</template>
<script>
import Num2persian from 'num2persian'
// import Panel from '../Tools/NetPa/Panel.vue';
import Payment from './Payment.vue'
import Loading from '../Tools/NetPa/Loading.vue'

export default {
  components: {
    Payment,
    Loading,
  },
  data() {
    return {
      Lodaingrenre: false,
      HesabForDeposit: null,
      MabFormulaJarime: 0,
      CheckUpMablagh: null,
      Mablagh: '',
      Email: '',
      Des: '',
      ListHesbForPar: null,
      TaahodatIdForGetRiz: null,
      VariszStatus: false,
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/GetShenaseVariz',
        Token: this.$session.get('TokenNetPa'),
      },
      ShenaseVariz: '',
      ListModel: [],
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      Resultcmb: null,
      TahoodSelected: null,
      ListTaahodatRiz: null,
      sumMabRiz: 0,
      GatewayCode: null,
      FixVariz: false,
      FixVarizHesabha: false,
      CountSelectedTaahodatRiz: 0,
      CountSelectedTaahodatRizMovaghat: 0,
      ListModelSahebHesab: null,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Enteghal: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'EnteghalVajh',
        Token: this.$session.get('TokenNetPa'),
      },
    }
  },
  computed: {
    Mab2persian() {
      var Mab = this.Mablagh.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      // Mab=Mab/10
      return Num2persian(Mab) + ' ' + this.$cookies.get('VahedPool')
    },
    GetMablagh() {
      var Mab = this.Mablagh.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      // Mab=Mab/10
      return this.$Comma3ragham(Mab) + ' ' + this.$cookies.get('VahedPool')
    },
  },
  updated() {
    this.$PutCommatoInput()
  },
  mounted() {
    document.getElementById('MabGhest').focus()
    if (this.TaahodatItem) {
      // this.GetTaahodatRiz(this.TaahodatItem.id);
      if (Number(this.TaahodatItem.mablaghSharj.replaceAll(/,/g, '')) > 0) {
        this.FixVarizHesabha = true
        this.Mablagh = Number(this.TaahodatItem.mablaghSharj.replaceAll(/,/g, '')) > 0 ? this.TaahodatItem.sumGhabelPar + '' : this.TaahodatItem.mablaghSharj + ''
      }
      this.GetShenase(this.TaahodatItem.vCode)
    }
    if (this.IsShowComboHesab && !this.IsTashilat) {
      this.GetListTaahodat2()
    }

    if (this.IsTashilat && this.IsShowComboHesab) {
      this.GetTashilat()
    }
    if (this.IsTashilat && !this.IsShowComboHesab) {
      if (this.mabTasveyeZodtar != undefined && this.mabTasveyeZodtar > 0) {
        this.FixVariz = true
        this.Mablagh = this.$Comma3ragham(this.mabTasveyeZodtar)
      } else {
        this.Mablagh = this.$Comma3ragham(this.TaahodatItem.sumGhabelPar)
        this.CheckUpMablagh = this.TaahodatItem.sumGhabelPar
      }
    }
  },
  methods: {
    GetShenase(Vcode) {
      const formData = new FormData()
      formData.append('Vcode', Vcode)
      this.DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(this.DataAxiosRow).then((data) => {
        this.ShenaseVariz = data

        return data
      })
    },
    GetListTaahodat2() {
      const formData = new FormData()
      let info
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId)
      this.DataAxios_cmbTaahodat.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true
          if (this.wwwtblSarfaslTypeId == undefined) {
            this.ListModel = data.filter((x) => x.isPayment == true && x.tblSarfaslTypeId != 6)
          } else {
            this.ListModel = data
          }

          // this.Resultcmb=data[0].id
          // this.TahoodSelected=data[0]
          // انتخاب حساب پیشفرض برای واریز (درخواست یگانه سخاوت)
          if (data.filter((x) => x.pishfarz == true)[0]) {
            this.Resultcmb = data.filter((x) => x.pishfarz == true)[0].id
            this.TahoodSelected = data.filter((x) => x.pishfarz == true)[0]
          } else {
            this.Resultcmb = data[0].id

            this.TahoodSelected = data[0]
          }
          if (this.TahoodSelected.mablaghSharj > 0) {
            this.Mablagh = this.TahoodSelected.sumGhabelPar == 0 ? this.$Comma3ragham(this.TahoodSelected.mablaghSharj) : this.$Comma3ragham(this.TahoodSelected.sumGhabelPar)
            this.FixVarizHesabha = true
          } else {
            this.FixVarizHesabha = false
          }
          // this.GetShenase(this.TahoodSelected.vCode);
        })
        .finally(() => {
          const formData = new FormData()
          formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
          formData.append('wwwtblSarfaslTypeId', this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId)
          this.DataAxios_SahebHesab.ArryfildValue = formData
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true
              this.ListModelSahebHesab = data.filter((x) => x.mande >= 0 && x.isPayment == true)
              for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
                // if((this.ListModelSahebHesab[index].mande-this.ListModelSahebHesab[index].sumMabTaeedNaShode)>0){
                info = this.ListModelSahebHesab[index]
                this.ListModel.push(info)
              }
              // }
            }
          })
        })
    },
    GetListTaahodatDargah() {
      const formData = new FormData()
      let info
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId)
      this.DataAxios_cmbTaahodat.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_cmbTaahodat).then((data) => {
        this.IsLoad = true
        if (this.wwwtblSarfaslTypeId == undefined) {
          this.ListHesbForPar = data.filter((x) => x.isPayment == true && x.tblSarfaslTypeId != 6)
        } else {
          this.ListHesbForPar = data
        }

        // this.GetShenase(this.TahoodSelected.vCode);
      })
    },
    FindTaahod(taahodId) {
      if (taahodId != -1) {
        this.ListModel.forEach((element) => {
          if (element.id == taahodId) {
            // this.GetTaahodatRiz(element.id);
            this.TahoodSelected = element
            this.GetShenase(this.TahoodSelected.vCode)
            this.Mablagh = this.$Comma3ragham(element.sumGhabelPar)
            if (element.sumGhabelPar > 0 && element.sumGhabelPar != null && this.FixVariz == true) {
              document.getElementById('MabGhest').disabled = true
            }

            this.CheckUpMablagh = element.sumGhabelPar
          }
        })
      }
    },
    Payment() {
      // console.log(this.IsTashilat);
      if (this.GatewayCode == 0) {
        if (this.$session.get('CustCode') == 801) {
          this.$swal(
            'اختلال در پرداخت با درگاه',
            "مشتری گرامی به علت  اختلال موقت درگاه ، لطفا به یکی از دو روش  پرداخت نمایید با تشکر . 1- کارت به کارت از طریق عابربانک ملی به همراه شناسه پرداخت یا شناسه واریز .  (کارت بانک ملی به شماره : 6037.9911.9952.6827)  2-  واریز به حساب از سامانه بام به همراه شناسه واریز یا شناسه پرداخت . (شماره حساب بانک ملی : 0110008020006)" ,
            'warning'
          )
        }
        else{
          this.$mySweetDefaultTost('عدم انتخاب درگاه', 'درگاهی برای سامانه تنظیم نشده است', 'warning', 3000)
        }
      } else {
        try {
          if (this.$session.get('CustCode') == 868) {
            if (this.IsTashilat != true) {
              if (Number(this.Mablagh.replaceAll(/,/g, '')) % 10000 === 0) {
                //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                //چهار رقم آخر صفر می باشد
                if (this.IsTashilat && !this.IsShowComboHesab) {
                  if (Number(this.Mablagh.replaceAll(/,/g, '')) > Number(this.TaahodatItem.mande.replaceAll(/,/g, '')) + Number(this.TaahodatItem.wwwJarime) - Number(this.TaahodatItem.sumMabTaeedNaShode.replaceAll(/,/g, ''))) {
                    //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                    this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
                  } else {
                    this.FormulaJarime()
                  }
                }
                if (this.IsTashilat && this.IsShowComboHesab) {
                  if (Number(this.Mablagh.replaceAll(/,/g, '')) > this.TahoodSelected.mande + this.TahoodSelected.wwwJarime - this.TahoodSelected.sumMabTaeedNaShode) {
                    //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                    this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
                  } else {
                    this.FormulaJarime()
                  }
                }
                if (!this.IsTashilat) {
                  this.SetPayment()
                }
              } else {
                //چهار رقم آخر صفر نیست
                this.$mySweetDefaultTost('خطا در مبلغ واریزی', 'سرمایه طبق دستور بانک مرکزی باید به صورت رند (چهار رقم آخر مبلغ صفر باشد) وارد شود لطفا مبلغ واریزی را بررسی کنید', 'warning', 7000)
              }
            }
            if (this.IsTashilat == true) {
              if (this.IsTashilat && !this.IsShowComboHesab) {
                if (Number(this.Mablagh.replaceAll(/,/g, '')) > Number(this.TaahodatItem.mande.replaceAll(/,/g, '')) + Number(this.TaahodatItem.wwwJarime) - Number(this.TaahodatItem.sumMabTaeedNaShode.replaceAll(/,/g, ''))) {
                  //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                  this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
                } else {
                  this.FormulaJarime()
                }
              }
              if (this.IsTashilat && this.IsShowComboHesab) {
                if (Number(this.Mablagh.replaceAll(/,/g, '')) > this.TahoodSelected.mande + this.TahoodSelected.wwwJarime - this.TahoodSelected.sumMabTaeedNaShode) {
                  //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                  this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
                } else {
                  this.FormulaJarime()
                }
              }
              if (!this.IsTashilat) {
                this.SetPayment()
              }
            }
          }
          else {
            if (this.IsTashilat && !this.IsShowComboHesab) {
              if (Number(this.Mablagh.replaceAll(/,/g, '')) > Number(this.TaahodatItem.mande.replaceAll(/,/g, '')) + Number(this.TaahodatItem.wwwJarime) - Number(this.TaahodatItem.sumMabTaeedNaShode.replaceAll(/,/g, ''))) {
                //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
              } else {
                this.FormulaJarime()
              }
            }
            if (this.IsTashilat && this.IsShowComboHesab) {
              if (Number(this.Mablagh.replaceAll(/,/g, '')) > this.TahoodSelected.mande + this.TahoodSelected.wwwJarime - this.TahoodSelected.sumMabTaeedNaShode) {
                //console.log('😎 ~ Payment ~ this.Mablagh:', this.Mablagh)
                this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
              } else {
                this.FormulaJarime()
              }
            }
            if (this.IsTashilat==false) {
              this.SetPayment()
            }
          }
          //--------------------------------------------------------------------------------------------
          this.$store.state.loadingRender = true
          this.$store.state.loadingRender = false
        } catch (error) {
          //--------------------------------------------------------------------------------------------
          this.$store.state.loadingRender = true
          this.$store.state.loadingRender = false
        }
      }
    },
    Payment2() {
      if (this.IsTashilat && !this.IsShowComboHesab) {
        if (Number(this.Mablagh.replaceAll(/,/g, '')) > Number(this.TaahodatItem.mande.replaceAll(/,/g, '')) + Number(this.TaahodatItem.wwwJarime) - Number(this.TaahodatItem.sumMabTaeedNaShode.replaceAll(/,/g, ''))) {
          //console.log('😎 ~ Payment2 ~ this.Mablagh:', this.Mablagh)
          this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
        } else {
          this.FormulaJarime2()
        }
      }
      if (this.IsTashilat && this.IsShowComboHesab) {
        if (Number(this.Mablagh.replaceAll(/,/g, '')) > this.TahoodSelected.mande + this.TahoodSelected.wwwJarime - this.TahoodSelected.sumMabTaeedNaShode) {
          //console.log('😎 ~ Payment2 ~ this.Mablagh:', this.Mablagh)
          this.$mySweetDefault('عدم پرداخت', 'مبلغ پرداختی بیشتر از مانده تسهیلات شما می باشد .', 'error', 3000)
        } else {
          this.FormulaJarime2()
        }
      }
    },
    FormulaJarime() {
      if (Number(this.Mablagh.replaceAll(/,/g, '')) < Number(this.CheckUpMablagh)) {
        //console.log('😎 ~ FormulaJarime ~ this.Mablagh:', this.Mablagh)
        var MablaghJarime = this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime
        this.MabFormulaJarime = (Number(this.Mablagh.replaceAll(/,/g, '')) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        this.SetPayment()
      } else {
        this.MabFormulaJarime = this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime
        this.SetPayment()
      }
    },
    FormulaJarime2() {
      if (Number(this.Mablagh.replaceAll(/,/g, '')) < Number(this.CheckUpMablagh)) {
        var MablaghJarime = this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime
        this.MabFormulaJarime = (Number(this.Mablagh.replaceAll(/,/g, '')) / (Number(this.CheckUpMablagh) - MablaghJarime)) * MablaghJarime
        this.SetPayment2()
      } else {
        this.MabFormulaJarime = this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime
        this.SetPayment2()
      }
    },
    GetTashilat() {
      const formData = new FormData()
      let info
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 1)
      this.DataAxios_cmbTaahodat.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true
          this.ListModel = []
          data.forEach((element) => {
            if (element.mande + element.wwwJarime - element.sumMabTaeedNaShode > 0) {
              this.ListModel.push(element)
              // console.error(data);
            }
          })
          this.Resultcmb = this.ListModel[0].id
          // this.GetTaahodatRiz(this.ListModel[0].id);
          this.TahoodSelected = this.ListModel[0]
          // console.log("@@@@",this.TahoodSelected);
          this.GetShenase(this.TahoodSelected.vCode)

          this.Mablagh = this.$Comma3ragham(this.ListModel[0].sumGhabelPar)
          this.CheckUpMablagh = this.ListModel[0].sumGhabelPar
        })
        .finally(() => {
          const formData = new FormData()
          formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
          formData.append('wwwtblSarfaslTypeId', 1)
          this.DataAxios_SahebHesab.ArryfildValue = formData
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true
              this.ListModelSahebHesab = data
              for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
                if (this.ListModelSahebHesab[index].mande - this.ListModelSahebHesab[index].sumMabTaeedNaShode > 0) {
                  info = this.ListModelSahebHesab[index]
                  this.ListModel.push(info)
                }
              }
            }
          })
        })
    },
    SetMablagh() {
      this.CountSelectedTaahodatRiz = this.CountSelectedTaahodatRizMovaghat
      if (this.$session.get('UserInfoNetPa').cId == '801' || this.$session.get('UserInfoNetPa').cId == '7777') {
        if (this.CountSelectedTaahodatRiz <= 1) {
          this.Mablagh = this.sumMabRiz + this.TahoodSelected.wwwJarime + ''
        } else {
          document.getElementById('MabJarime').textContent = 'ندارد'
          this.Mablagh = this.sumMabRiz + ''
        }
      } else {
        this.Mablagh = this.sumMabRiz + this.TahoodSelected.wwwJarime + ''
      }
    },
    Get_GatewayCode(val) {

      this.GatewayCode = val
      if (this.GatewayCode == 100) {
        // this.GetListTaahodat2()
        this.GetListTaahodatDargah()
      }
    },
    FixVarizGhest(val) {
      // if (this.mabTasveyeZodtar == 0 || this.mabTasveyeZodtar == undefined)
      this.FixVariz = val
    },
    SumMablagh(val) {
      var jarime = this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime
      this.Mablagh = val + jarime + ''
    },
    SetPayment() {
      // console.log(this.TaahodatItem);
      // console.log(this.TahoodSelected);
      var SharhRiz = ''
      if (this.mabTasveyeZodtar > 0 && this.mabReturnrKarmozd > 0) SharhRiz = this.TaahodatItem.vCode + ' تسویه زود تر از موعد '
      else SharhRiz = (this.TaahodatItem ? this.TaahodatItem.vCode : this.TahoodSelected.vCode) + 'پرداخت/ واریز  تکی'
      const WwwtblVarizGorohiRiz = []
      WwwtblVarizGorohiRiz.push({
        WwwtblTaahodatId: this.TaahodatItem ? this.TaahodatItem.id : this.TahoodSelected.id,
        Mablagh: Number(this.Mablagh.replaceAll(/,/g, '')),
        SharhRiz: SharhRiz,
        WwwtblAzaId: this.TaahodatItem ? this.TaahodatItem.wwwtblAzaId : this.TahoodSelected.wwwtblAzaId,
        BnpCashDBtblTaahodatId: this.TaahodatItem ? this.TaahodatItem.bnpCashDBtblTaahodatId : this.TahoodSelected.bnpCashDBtblTaahodatId,
        BnpCashDBtblAzaId: this.TaahodatItem ? this.TaahodatItem.bnpCashDBtblAzaId : this.TahoodSelected.bnpCashDBtblAzaId,
        MablaghJarime: Math.floor(this.MabFormulaJarime), //this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime,
        TarixGhest: this.TaahodatItem ? this.TaahodatItem.minTarGhestBedehkar.replaceAll(/,/g, '') : this.TahoodSelected.minTarGhestBedehkar.replaceAll(/,/g, ''),
        IsTaahodatRiz: false,
        MabReturnrKarmozd: this.mabReturnrKarmozd > 0 ? this.mabReturnrKarmozd : 0,
      })
      ;(this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh.replaceAll(/,/g, ''))), (this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0)
      this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.Sharh = this.mabTasveyeZodtar > 0 && this.mabReturnrKarmozd > 0 ? ' تسویه زود تر از موعد ' : 'پرداخت/ واریز  تکی'
      this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
      this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('UserInfoNetPa').custCode)
      this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
      this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.$session.get('UserInfoNetPa').wwwtblAzaId
      this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
      this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
      this.$PostData(this.DataAxios_Variz).then((result) => {
        if (result.status === 'Success') {
          this.$Payment(
            this.GatewayCode + '',
            this.Mablagh,
            this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily,
            this.$session.get('UserInfoNetPa').email,
            this.$session.get('UserInfoNetPa').mobile,
            WwwtblVarizGorohiRiz[0].WwwtblTaahodatId,
            this.TaahodatItem ? this.TaahodatItem.shenaseVariz : this.TahoodSelected.shenaseVariz,
            this.TaahodatItem ? this.TaahodatItem.vCode : this.TahoodSelected.vCode,
            'پرداخت/واریز تکی',
            JSON.stringify(this.$session.get('UserInfoNetPa').wwwtblAzaId),
            this.$session.get('UserInfoNetPa').custCode,
            JSON.stringify(this.$session.get('UserInfoNetPa').wwwtblShobeId),
            result.idRepoMaster,
            this.$session.get('UserInfoNetPa').codeMeli,
            this.TaahodatItem?this.TaahodatItem.nameFamily : this.TahoodSelected.nameFamily,
            this.TaahodatItem?this.TaahodatItem.mobile:this.TahoodSelected.mobile,
            this.TaahodatItem?this.TaahodatItem.codeMeli.trim():this.TahoodSelected.codeMeli.trim()
          )
        } else {
          this.$mySweetDefaultTost(' ', ' در پرداخت مشکلی پیش آمده لطفا مجددا تلاش فرمایید', 'warning', 2000)
          this.DeleteAllItemsCart()
        }
      })
    },
    SetPayment2() {
      var SharhRiz = ''
      if (this.mabTasveyeZodtar > 0 && this.mabReturnrKarmozd > 0) SharhRiz = this.TaahodatItem.vCode + ' تسویه زود تر از موعد از حساب'
      else SharhRiz = (this.TaahodatItem ? this.TaahodatItem.vCode : this.TahoodSelected.vCode) + ' پرداخت/ واریز  تکی از حساب'

      // console.log(Number(this.HesabForDeposit.ghabelBardasht) + Number(this.HesabForDeposit.sumMabTaeedNaShode))
      // console.log(Number(this.Mablagh.replaceAll(/,/g, '')))
      if (Number(this.HesabForDeposit.ghabelBardasht) + Number(this.HesabForDeposit.sumMabTaeedNaShode) < Number(this.Mablagh.replaceAll(/,/g, ''))) {
        this.$mySweetDefaultTost('عدم موجودی', 'موجودی حساب شما کمتراز مبلغ اقساط شما می باشد ', 'error', 3000)
        return
      } else {
        this.Lodaingrenre = true
        const WwwtblVarizGorohiRiz = []
        /*wwwtblTaahodatIdBestanKar*/
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: this.TaahodatItem ? this.TaahodatItem.id : this.TahoodSelected.id,
          Mablagh: Number(this.Mablagh.replaceAll(/,/g, '')),
          SharhRiz: SharhRiz,
          WwwtblAzaId: this.TaahodatItem ? this.TaahodatItem.wwwtblAzaId : this.TahoodSelected.wwwtblAzaId,
          BnpCashDBtblTaahodatId: this.TaahodatItem ? this.TaahodatItem.bnpCashDBtblTaahodatId : this.TahoodSelected.bnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.TaahodatItem ? this.TaahodatItem.bnpCashDBtblAzaId : this.TahoodSelected.bnpCashDBtblAzaId,
          MablaghJarime: Math.floor(this.MabFormulaJarime), //this.TaahodatItem ? this.TaahodatItem.wwwJarime : this.TahoodSelected.wwwJarime,
          TarixGhest: this.TaahodatItem ? this.TaahodatItem.minTarGhestBedehkar.replaceAll(/,/g, '') : this.TahoodSelected.minTarGhestBedehkar.replaceAll(/,/g, ''),
          IsTaahodatRiz: false,
          MabReturnrKarmozd: this.mabReturnrKarmozd > 0 ? this.mabReturnrKarmozd : 0,
        })

        /*wwwtblTaahodatIdBestanKar*/

        this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.Mablagh.replaceAll(/,/g, ''))
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$GetJalaliDate()
        this.DataAxios_Variz.ArryfildValue.Sharh = SharhRiz
        this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$GetJalaliDateTime()
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('UserInfoNetPa').custCode)
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.$session.get('UserInfoNetPa').wwwtblAzaId
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz

        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === 'Success') {
            //console.log('😎 ~ this.$PostData ~ result:', result)

            ////کدهای ثبت انتقال وجه
            const formData = new FormData()
            if (this.Result != null) {
              formData.append('wwwtblTaahodatIdBestanKar', this.TaahodatItem ? this.TaahodatItem.id : this.TahoodSelected.id)
            } else {
              formData.append('wwwtblTaahodatIdBestanKar', this.TaahodatItem ? this.TaahodatItem.id : this.TahoodSelected.id)
            }
            formData.append('wwwtblTaahodatIdBedehKar', this.HesabForDeposit.id)
            formData.append('Mablagh', Number(this.Mablagh.replaceAll(/,/g, '')))
            formData.append('Desc', SharhRiz)
            formData.append('KodRahgiri', '')
            formData.append('CardNo', '')
            formData.append('ShebaNo', '')
            formData.append('NameSahebHesab', this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily)
            formData.append('EnteghalNoe', 2)
            formData.append('HesabNo', '')
            formData.append('OrderId', '-2')
            formData.append('MabKarmozdEnteghal', 0)
            formData.append('MabKarmozdBnp', 0)
            formData.append('BankName', '')
            formData.append('ComboIdGrp324', 0)
            formData.append('TarixSanad', this.$GetJalaliDate())
            formData.append('VarizGorohiId', result.idRepoMaster)
            formData.append('wwwJarime', this.MabFormulaJarime)
            this.DataAxios_Enteghal.ArryfildValue = formData
            this.$PostFormData(this.DataAxios_Enteghal)
              .then((data) => {
                if (data.id > 0 && data.success == 'SUCCESS') {
                  this.$mySweetDefaultTost('انتقال موفق', 'انتقال وجه با موفقیت انجام شد کد رهگیری : ' + data.codeRahgiri, 'success', 6000)
                } else {
                  this.$mySweetDefaultTost('مشکل در انتقال وجه', 'مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید', 'warning', 3000)
                }
              })
              .finally(() => {
                this.Lodaingrenre = false
              })

            ////کدهای ثبت انتقال وجه
          }
        })
      }
    },
  },
  created() {

    if (this.wwwtblAzaId) {
      this.$session.set('UserFromLoan', [this.wwwtblAzaId, false])
    }
    if (this.wwwtblAzaIdAccount) {
      this.$session.set('UserFromAccount', [this.wwwtblAzaIdAccount, false])
    }
  },
  props: ['IsShowComboHesab', 'TaahodatItem', 'IsTashilat', 'wwwtblAzaId', 'wwwtblAzaIdAccount', 'mabTasveyeZodtar', 'mabReturnrKarmozd'],
}
</script>
<style scoped>
.card {
  border-radius: 15px !important;
}

.bg-dark-Custom {
  background: #2a3f54 !important;
  /* border:1px solid #2A3F54 !important; */
}

.border-warning {
  border-bottom: 1px dashed #ff9800 !important;
}

.btn-outline-orange {
  background: #fff;
}

.bg-success-custom {
  background: #d1bd9e !important;
}

.btn-outline-success {
  background: #ffffff !important;
}

.btn-outline-success:hover {
  background: #5ea31e !important;
  color: #fff;
}
</style>
